module.exports = __webpack_public_path__ + "img/CT.Bridges.Parapets.Concrete_Parapet_(H4a).Pre-cast_Reinforced_Concrete.7b771fb8.png";